// @ts-nocheck

import {useState} from "react";
import {auth} from '../../firebaseApp.ts';
import {signInWithEmailAndPassword, signOut} from "firebase/auth";
import {Link, useSearchParams} from "react-router-dom";
import FormError from "./FormError.tsx";
import {Logo} from "../../components/specific/Logo.tsx";
import {PasswordInput} from "../../components/form/PasswordInput.tsx";
import {SocialSignInButtons} from "../../components/auth/SocialSignInButtons.tsx";

const emailNotVerifiedMessage =
    'Je moet eerst je e-mailadres bevestigen voordat je kunt inloggen. ' +
    'Klik op de bevestigingslink in de e-mail die je van ons hebt ontvangen om je account te activeren. ' +
    'Geen e-mail ontvangen? Controleer dan ook je spamfolder.';

export function Login() {

    const [params, setParams] = useSearchParams();
    const [formError, setFormError] = useState(params.get('error') || '');

    async function signInWithEmail(email, password) {
        try {
            await signInWithEmailAndPassword(auth, email, password);

            const {claims} = await auth.currentUser.getIdTokenResult(true);

            if (!claims.email_verified) {
                await signOut(auth);
                window.location.replace('/?error=' + encodeURIComponent(emailNotVerifiedMessage));
                return;
            }
        } catch (err) {
            setFormError(err);
        }
    }

    const [userEmail, setUserEmail] = useState('');
    const [userPassword, setUserPassword] = useState('');

    return (
        <>
            <div className="flex min-h-screen flex-1">
                <div className="flex flex-1 flex-col justify-center px-4 py-12 sm:px-6 lg:flex-none lg:px-20 xl:px-24">
                    <div className="mx-auto w-full max-w-sm lg:w-96">
                        <div>
                            <div className="absolute top-16">
                                <Logo/>
                            </div>
                            <h2 className="mt-8 text-3xl font-bold leading-9 tracking-tight text-gray-900 mt-24 md:mt-2">
                                Log in op je account
                            </h2>
                        </div>

                        <div className="mt-10">
                            <SocialSignInButtons/>

                            <div className="relative my-6">
                                <div className="absolute inset-0 flex items-center" aria-hidden="true">
                                    <div className="w-full border-t border-gray-300"/>
                                </div>
                                <div className="relative flex justify-center text-sm">
                                    <span className="bg-white px-2 text-gray-500">of</span>
                                </div>
                            </div>

                            <div>
                                <form action="#" method="POST" className="space-y-6" onSubmit={(e) => {
                                    e.preventDefault()
                                    signInWithEmail(userEmail, userPassword)
                                }}>
                                    <div>
                                        <label htmlFor="email"
                                               className="block text-sm font-medium leading-6 text-gray-900">
                                            E-mailadres
                                        </label>
                                        <div className="mt-2">
                                            <input
                                                id="email"
                                                name="email"
                                                type="email"
                                                required
                                                onChange={(e) => setUserEmail(e.target.value)}
                                                autoComplete="email"
                                                className="px-2 block w-full rounded-md border-0 py-1.5 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-primary sm:text-sm sm:leading-6"
                                            />
                                        </div>
                                    </div>

                                    <div>
                                        <label htmlFor="password"
                                               className="flex justify-between text-sm font-medium leading-6 text-gray-900">
                                            <span>Wachtwoord</span>
                                            <Link
                                                to='/reset-password'
                                               className="font-semibold text-primary hover:text-primary hover:opacity-70">
                                                Wachtwoord vergeten?
                                            </Link>
                                        </label>
                                        <div className="mt-2">
                                            <PasswordInput
                                                id="password"
                                                name="password"
                                                required
                                                onChange={(e) => setUserPassword(e.target.value)}
                                                autoComplete="current-password"
                                            />
                                        </div>
                                    </div>

                                    {formError && <FormError message={formError}/>}
                                    <div>
                                        <button
                                            type="submit"
                                            className="flex w-full justify-center rounded-md bg-primary px-3 py-1.5 text-sm font-semibold leading-6 text-white shadow-sm hover:bg-primary hover:opacity-70 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-primary"
                                        >
                                            Inloggen
                                        </button>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="relative hidden w-0 flex-1 lg:block">
                    <img
                        alt=""
                        src="https://images.unsplash.com/photo-1496917756835-20cb06e75b4e?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=1908&q=80"
                        className="absolute inset-0 h-full w-full object-cover"
                    />
                </div>
            </div>
        </>
    )
}
